// extracted by mini-css-extract-plugin
module.exports = {"counter":"counter_counter__1W91L","default":"counter_default__3wxRv","small":"counter_small__7Xx6z","counter__num":"counter_counter__num__2rjRt"};